export default __webpack_public_path__ + "static/media/UniversLTStd-LightUltraCn.d009632d.otf";